module.exports = __webpack_public_path__ + "img/Andrew_C_Circle.b1d3bf53.png";